import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M6.425 16.042h8.75c.92 0 1.666-.747 1.666-1.667V8.19c0-.442-.175-.866-.488-1.178l-2.565-2.565a1.666 1.666 0 0 0-1.179-.489H6.425c-.92 0-1.667.747-1.667 1.667v8.75c0 .92.746 1.667 1.667 1.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M8.091 15.833v-2.708c0-.46.374-.833.834-.833h3.75c.46 0 .833.373.833.833v2.708M8.091 4.167v2.708" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);